import { en } from './copy/en/index.ts';
import { vi } from './copy/vi/index.ts';
import type { Locale } from './locales.ts';
import type { Copy } from './types.ts';

export * from './legal/index.ts';
export * from './locales.ts';
export * from './routes.ts';
export { CONTENT_COVERAGE_OK, type Copy, type PageSeo } from './types.ts';

const DICTIONARY: Record<Locale, Copy> = { vi, en };

/**
 * Toàn bộ nội dung của một ngôn ngữ.
 *
 * Cố tình KHÔNG có hàm `t('a.b.c')` tra chuỗi bằng khoá dạng text: tra kiểu đó mất hết kiểm
 * tra kiểu, đổi tên khoá phải mò bằng grep, và khoá gõ sai chỉ lộ ra lúc chạy. Ở đây truy cập
 * thẳng object nên IDE tự gợi ý và `tsc` chặn mọi khoá sai.
 */
export function getCopy(locale: Locale): Copy {
  return DICTIONARY[locale];
}
